// extracted by mini-css-extract-plugin
module.exports = {"product":"styles_product__WBlNc","productWrapper":"styles_productWrapper__ixN5S"};